import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';

interface SectionProps extends StandaloneComponentProps {
  title: string;
  components: (() => JSX.Element)[];
}

export const Section: StandaloneComponent<SectionProps> = ({ title, components }) => (
  <section className="m-6 flex flex-col gap-y-6">
    <h2 className="mx-auto w-full max-w-screen-xl text-primary-700 text-headline-xl">{title}</h2>

    {components.map((Component, idx) => (
      <Component key={Component.name ?? idx} />
    ))}
  </section>
);
